DR.crazywolf = DR.crazywolf || {};
DR.crazywolf.struct = DR.crazywolf.struct || {};
DR.crazywolf.select = DR.crazywolf.select || {};
/** @extends {DR._Base} */
DR.crazywolf.struct.Task = function(par){
	/** @private */
	this._t = 1041;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.completed)) this.completed = Boolean(par.completed);
	if(DR._Base.is(par.declineReason)) this.declineReason = String(par.declineReason||'');
	if(DR._Base.is(par.id)) this.id = (parseInt(par.id)||0);
	if(DR._Base.is(par.image)) this.image = DR._Base.cast(par.image);
	if(DR._Base.is(par.order)) this.order = (parseInt(par.order)||0);
	if(DR._Base.is(par.points)) this.points = (parseInt(par.points)||0);
	if(DR._Base.is(par.status)) this.status = Number(par.status);
	if(DR._Base.is(par.taskImage)) this.taskImage = DR._Base.cast(par.taskImage);
	if(DR._Base.is(par.taskVideo)) this.taskVideo = DR._Base.cast(par.taskVideo);
	if(DR._Base.is(par.text)) this.text = String(par.text||'');
	if(DR._Base.is(par.type)) this.type = Number(par.type);
	if(DR._Base.is(par.video)) this.video = DR._Base.cast(par.video);
};
DR._Base._types[1041] = DR.crazywolf.struct.Task;
DR.crazywolf.struct.Task.STATUS_SUBMITTED = 0;
DR.crazywolf.struct.Task.STATUS_ACCEPTED = 1;
DR.crazywolf.struct.Task.STATUS_DECLINED = 2;
DR.crazywolf.struct.Task.TYPE_IMAGE = 1;
DR.crazywolf.struct.Task.TYPE_VIDEO = 2;
DR.crazywolf.struct.Task[__P] = new DR._Base;
DR.crazywolf.struct.Task[__P][__C] = DR.crazywolf.struct.Task;
/** @type {Boolean} */
DR.crazywolf.struct.Task.prototype.completed = null;
/** @type {String|null} */
DR.crazywolf.struct.Task.prototype.declineReason = null;
/** @type {Number} */
DR.crazywolf.struct.Task.prototype.id = null;
/** @type {DR.roadgames.struct.Image|null} */
DR.crazywolf.struct.Task.prototype.image = null;
/** @type {Number} */
DR.crazywolf.struct.Task.prototype.order = null;
/** @type {Number} */
DR.crazywolf.struct.Task.prototype.points = null;
/** @type {Number|null} */
DR.crazywolf.struct.Task.prototype.status = null;
/** @type {DR.roadgames.struct.Image|null} */
DR.crazywolf.struct.Task.prototype.taskImage = null;
/** @type {DR.roadgames.struct.Video|null} */
DR.crazywolf.struct.Task.prototype.taskVideo = null;
/** @type {String} */
DR.crazywolf.struct.Task.prototype.text = null;
/** @type {Number} */
DR.crazywolf.struct.Task.prototype.type = null;
/** @type {DR.roadgames.struct.Video|null} */
DR.crazywolf.struct.Task.prototype.video = null;

/** @extends {DR._Base} */
DR.crazywolf.struct.Tasks = function(par){
	/** @private */
	this._t = 1042;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.tasks)){
		var tmp = [];
		for( var k in par.tasks ) tmp.push(DR._Base.cast(par.tasks [k]));
		this.tasks = tmp;
	}
};
DR._Base._types[1042] = DR.crazywolf.struct.Tasks;
DR.crazywolf.struct.Tasks[__P] = new DR._Base;
DR.crazywolf.struct.Tasks[__P][__C] = DR.crazywolf.struct.Tasks;
/** @type {Array.<DR.crazywolf.struct.Task>} */
DR.crazywolf.struct.Tasks.prototype.tasks = null;

/** @extends {DR._Base} */
DR.crazywolf.struct.Consent = function(par){
	/** @private */
	this._t = 1231;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.consent)) this.consent = Boolean(par.consent);
	if(DR._Base.is(par.image)) this.image = DR._Base.cast(par.image);
	if(DR._Base.is(par.text)) this.text = String(par.text||'');
	if(DR._Base.is(par.title)) this.title = String(par.title||'');
};
DR._Base._types[1231] = DR.crazywolf.struct.Consent;
DR.crazywolf.struct.Consent[__P] = new DR._Base;
DR.crazywolf.struct.Consent[__P][__C] = DR.crazywolf.struct.Consent;
/** @type {Boolean|null} */
DR.crazywolf.struct.Consent.prototype.consent = null;
/** @type {DR.roadgames.struct.Pic|null} */
DR.crazywolf.struct.Consent.prototype.image = null;
/** @type {String} */
DR.crazywolf.struct.Consent.prototype.text = null;
/** @type {String} */
DR.crazywolf.struct.Consent.prototype.title = null;

/** @extends {DR._Method} */
DR.crazywolf.GetTasks = function(par){
	this.select = [];
	/** @private */
	this._t = 1043;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1043] = DR.crazywolf.GetTasks;
DR.crazywolf.GetTasks[__CL] = "CrazyWolf__GetTasks";
DR.crazywolf.GetTasks[__P] = new DR._Method;
DR.crazywolf.GetTasks[__P][__C] = DR.crazywolf.GetTasks;
/** @type {DR.crazywolf.struct.Tasks} */
DR.crazywolf.GetTasks.prototype.re = null;

/** @extends {DR._Method} */
DR.crazywolf.SubmitTask = function(par){
	this.select = [];
	/** @private */
	this._t = 1044;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1044] = DR.crazywolf.SubmitTask;
DR.crazywolf.SubmitTask[__CL] = "CrazyWolf__SubmitTask";
DR.crazywolf.SubmitTask[__P] = new DR._Method;
DR.crazywolf.SubmitTask[__P][__C] = DR.crazywolf.SubmitTask;
/** @type {Number} */
DR.crazywolf.SubmitTask.prototype.taskId = null;
/** @type {Number} */
DR.crazywolf.SubmitTask.prototype.tmpId = null;
/** @type {DR.crazywolf.struct.Task} */
DR.crazywolf.SubmitTask.prototype.re = null;

/** @extends {DR._Base} */
DR.crazywolf.struct.UploadRe = function(par){
	/** @private */
	this._t = 1045;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.error)) this.error = String(par.error||'');
	if(DR._Base.is(par.task)) this.task = DR._Base.cast(par.task);
	if(DR._Base.is(par.uploadError)) this.uploadError = String(par.uploadError||'');
	if(DR._Base.is(par.uploadErrorNr)) this.uploadErrorNr = (parseInt(par.uploadErrorNr)||0);
};
DR._Base._types[1045] = DR.crazywolf.struct.UploadRe;
DR.crazywolf.struct.UploadRe[__P] = new DR._Base;
DR.crazywolf.struct.UploadRe[__P][__C] = DR.crazywolf.struct.UploadRe;
/** @type {String|null} */
DR.crazywolf.struct.UploadRe.prototype.error = null;
/** @type {DR.crazywolf.struct.Task|null} */
DR.crazywolf.struct.UploadRe.prototype.task = null;
/** @type {String|null} */
DR.crazywolf.struct.UploadRe.prototype.uploadError = null;
/** @type {Number|null} */
DR.crazywolf.struct.UploadRe.prototype.uploadErrorNr = null;

/** @extends {DR._Method} */
DR.crazywolf.GetCompleted = function(par){
	this.select = [];
	/** @private */
	this._t = 1145;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1145] = DR.crazywolf.GetCompleted;
DR.crazywolf.GetCompleted[__CL] = "CrazyWolf__GetCompleted";
DR.crazywolf.GetCompleted[__P] = new DR._Method;
DR.crazywolf.GetCompleted[__P][__C] = DR.crazywolf.GetCompleted;
/** @type {DR.crazywolf.struct.Tasks} */
DR.crazywolf.GetCompleted.prototype.re = null;

/** @extends {DR._Method} */
DR.crazywolf.GetConsent = function(par){
	this.select = [];
	/** @private */
	this._t = 1232;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1232] = DR.crazywolf.GetConsent;
DR.crazywolf.GetConsent[__CL] = "CrazyWolf__GetConsent";
DR.crazywolf.GetConsent[__P] = new DR._Method;
DR.crazywolf.GetConsent[__P][__C] = DR.crazywolf.GetConsent;
/** @type {DR.crazywolf.struct.Consent} */
DR.crazywolf.GetConsent.prototype.re = null;

/** @extends {DR._Method} */
DR.crazywolf.SetConsent = function(par){
	this.select = [];
	/** @private */
	this._t = 1233;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1233] = DR.crazywolf.SetConsent;
DR.crazywolf.SetConsent[__CL] = "CrazyWolf__SetConsent";
DR.crazywolf.SetConsent[__P] = new DR._Method;
DR.crazywolf.SetConsent[__P][__C] = DR.crazywolf.SetConsent;
/** @type {Boolean} */
DR.crazywolf.SetConsent.prototype.consent = null;
/** @type {DR.roadgames.struct.Status} */
DR.crazywolf.SetConsent.prototype.re = null;

D.loaded();